module.exports = __webpack_public_path__ + "img/P150T_weapon_133.5ad01a74.png";